import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[appClickOutsideBible]'
})
export class ClickOutsideBibleDirective {

  @Input('appClickOutsideBible') canReadClick!: boolean;
  @Output() outsideClick: EventEmitter<MouseEvent> = new EventEmitter();

  constructor(private _elementRef: ElementRef) { }

  @HostListener('document:mousedown', ['$event'])
    onClick(event: MouseEvent): void {

    const target = event.target as HTMLElement;
    const classList = target.classList;

    if (this.canReadClick) {
      const clickedInside = this._elementRef.nativeElement.contains(target);
      const hasRelevantClass = ['reader-chapter', 'reader-verse', 'reader-verse-text'].some(cls => classList.contains(cls));

      if (!hasRelevantClass && !clickedInside) {
        this.outsideClick.emit(event);
      }
    }

  }

}
